/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "jana",
        "-2": "juzi",
        "0": "leo",
        "1": "kesho",
        "2": "kesho kutwa",
        "future": {
          "one": "baada ya siku {0}",
          "other": "baada ya siku {0}"
        },
        "past": {
          "one": "siku {0} iliyopita",
          "other": "siku {0} zilizopita"
        }
      },
      "day-narrow": {
        "-1": "jana",
        "-2": "juzi",
        "0": "leo",
        "1": "kesho",
        "2": "kesho kutwa",
        "future": {
          "one": "baada ya siku {0}",
          "other": "baada ya siku {0}"
        },
        "past": {
          "one": "siku {0} iliyopita",
          "other": "siku {0} zilizopita"
        }
      },
      "day-short": {
        "-1": "jana",
        "-2": "juzi",
        "0": "leo",
        "1": "kesho",
        "2": "kesho kutwa",
        "future": {
          "one": "baada ya siku {0}",
          "other": "baada ya siku {0}"
        },
        "past": {
          "one": "siku {0} iliyopita",
          "other": "siku {0} zilizopita"
        }
      },
      "hour": {
        "0": "saa hii",
        "future": {
          "one": "baada ya saa {0}",
          "other": "baada ya saa {0}"
        },
        "past": {
          "one": "saa {0} iliyopita",
          "other": "saa {0} zilizopita"
        }
      },
      "hour-narrow": {
        "0": "saa hii",
        "future": {
          "one": "baada ya saa {0}",
          "other": "baada ya saa {0}"
        },
        "past": {
          "one": "Saa {0} iliyopita",
          "other": "Saa {0} zilizopita"
        }
      },
      "hour-short": {
        "0": "saa hii",
        "future": {
          "one": "baada ya saa {0}",
          "other": "baada ya saa {0}"
        },
        "past": {
          "one": "saa {0} iliyopita",
          "other": "saa {0} zilizopita"
        }
      },
      "minute": {
        "0": "dakika hii",
        "future": {
          "one": "baada ya dakika {0}",
          "other": "baada ya dakika {0}"
        },
        "past": {
          "one": "dakika {0} iliyopita",
          "other": "dakika {0} zilizopita"
        }
      },
      "minute-narrow": {
        "0": "dakika hii",
        "future": {
          "one": "baada ya dakika {0}",
          "other": "baada ya dakika {0}"
        },
        "past": {
          "one": "dakika {0} iliyopita",
          "other": "dakika {0} zilizopita"
        }
      },
      "minute-short": {
        "0": "dakika hii",
        "future": {
          "one": "baada ya dakika {0}",
          "other": "baada ya dakika {0}"
        },
        "past": {
          "one": "dakika {0} iliyopita",
          "other": "dakika {0} zilizopita"
        }
      },
      "month": {
        "-1": "mwezi uliopita",
        "0": "mwezi huu",
        "1": "mwezi ujao",
        "future": {
          "one": "baada ya mwezi {0}",
          "other": "baada ya miezi {0}"
        },
        "past": {
          "one": "mwezi {0} uliopita",
          "other": "miezi {0} iliyopita"
        }
      },
      "month-narrow": {
        "-1": "mwezi uliopita",
        "0": "mwezi huu",
        "1": "mwezi ujao",
        "future": {
          "one": "baada ya mwezi {0}",
          "other": "baada ya miezi {0}"
        },
        "past": {
          "one": "mwezi {0} uliopita",
          "other": "miezi {0} iliyopita"
        }
      },
      "month-short": {
        "-1": "mwezi uliopita",
        "0": "mwezi huu",
        "1": "mwezi ujao",
        "future": {
          "one": "baada ya mwezi {0}",
          "other": "baada ya miezi {0}"
        },
        "past": {
          "one": "mwezi {0} uliopita",
          "other": "miezi {0} iliyopita"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "robo ya mwaka iliyopita",
        "0": "robo hii ya mwaka",
        "1": "robo ya mwaka inayofuata",
        "future": {
          "one": "baada ya robo {0}",
          "other": "baada ya robo {0}"
        },
        "past": {
          "one": "robo {0} iliyopita",
          "other": "robo {0} zilizopita"
        }
      },
      "quarter-narrow": {
        "-1": "robo ya mwaka iliyopita",
        "0": "robo hii ya mwaka",
        "1": "robo ya mwaka inayofuata",
        "future": {
          "one": "baada ya robo {0}",
          "other": "baada ya robo {0}"
        },
        "past": {
          "one": "robo {0} iliyopita",
          "other": "robo {0} zilizopita"
        }
      },
      "quarter-short": {
        "-1": "robo ya mwaka iliyopita",
        "0": "robo hii ya mwaka",
        "1": "robo ya mwaka inayofuata",
        "future": {
          "one": "baada ya robo {0}",
          "other": "baada ya robo {0}"
        },
        "past": {
          "one": "robo {0} iliyopita",
          "other": "robo {0} zilizopita"
        }
      },
      "second": {
        "0": "sasa hivi",
        "future": {
          "one": "baada ya sekunde {0}",
          "other": "baada ya sekunde {0}"
        },
        "past": {
          "one": "Sekunde {0} iliyopita",
          "other": "Sekunde {0} zilizopita"
        }
      },
      "second-narrow": {
        "0": "sasa hivi",
        "future": {
          "one": "baada ya sekunde {0}",
          "other": "baada ya sekunde {0}"
        },
        "past": {
          "one": "sekunde {0} iliyopita",
          "other": "sekunde {0} zilizopita"
        }
      },
      "second-short": {
        "0": "sasa hivi",
        "future": {
          "one": "baada ya sekunde {0}",
          "other": "baada ya sekunde {0}"
        },
        "past": {
          "one": "sekunde {0} iliyopita",
          "other": "sekunde {0} zilizopita"
        }
      },
      "week": {
        "-1": "wiki iliyopita",
        "0": "wiki hii",
        "1": "wiki ijayo",
        "future": {
          "one": "baada ya wiki {0}",
          "other": "baada ya wiki {0}"
        },
        "past": {
          "one": "wiki {0} iliyopita",
          "other": "wiki {0} zilizopita"
        }
      },
      "week-narrow": {
        "-1": "wiki iliyopita",
        "0": "wiki hii",
        "1": "wiki ijayo",
        "future": {
          "one": "baada ya wiki {0}",
          "other": "baada ya wiki {0}"
        },
        "past": {
          "one": "wiki {0} iliyopita",
          "other": "wiki {0} zilizopita"
        }
      },
      "week-short": {
        "-1": "wiki iliyopita",
        "0": "wiki hii",
        "1": "wiki ijayo",
        "future": {
          "one": "baada ya wiki {0}",
          "other": "baada ya wiki {0}"
        },
        "past": {
          "one": "wiki {0} iliyopita",
          "other": "wiki {0} zilizopita"
        }
      },
      "year": {
        "-1": "mwaka uliopita",
        "0": "mwaka huu",
        "1": "mwaka ujao",
        "future": {
          "one": "baada ya mwaka {0}",
          "other": "baada ya miaka {0}"
        },
        "past": {
          "one": "mwaka {0} uliopita",
          "other": "miaka {0} iliyopita"
        }
      },
      "year-narrow": {
        "-1": "mwaka uliopita",
        "0": "mwaka huu",
        "1": "mwaka ujao",
        "future": {
          "one": "baada ya mwaka {0}",
          "other": "baada ya miaka {0}"
        },
        "past": {
          "one": "mwaka {0} uliopita",
          "other": "miaka {0} iliyopita"
        }
      },
      "year-short": {
        "-1": "mwaka uliopita",
        "0": "mwaka huu",
        "1": "mwaka ujao",
        "future": {
          "one": "baada ya mwaka {0}",
          "other": "baada ya miaka {0}"
        },
        "past": {
          "one": "mwaka {0} uliopita",
          "other": "miaka {0} iliyopita"
        }
      }
    },
    "locale": "sw"
  });
}